<template>
    <tr @dblclick="$refs['actions'].callFirstStarredAction();"
        class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
        <td class="d-block d-lg-table-cell">
            <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Application') }}</span>
            <FieldReadonly :value="applicationProfile.name" />
        </td>
        <td class="d-block d-lg-table-cell">
            <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Profiles') }}</span>
            <div v-for="profile in applicationProfile.profiles" :key="profile.id">
                <UserProfileBadge :profile="profile" />
                <Tooltip :title="i18n('Pending approval')" v-if="profile.is_pending_approval">
                    <PendingApprovalIcon />
                </Tooltip>
                {{ profile.name }}
                {{ profile.expires_at ? `(${getDate(profile.expires_at)})` : '' }}
            </div>
        </td>
        <td class="d-block d-lg-table-cell">
            <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Application Username') }}</span>
            <FieldReadonly v-if="applicationProfile?.is_identity" :value="applicationProfile.username" />
        </td>
        <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
            <ActionDropdown ref="actions" :actions="actions" />
        </td>
    </tr>
</template>

<script>
import {
    formatDate,
} from "@/tools/date.js";
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";
import UserProfileBadge from "@/components/userProfile/UserProfileBadge.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";
import PendingApprovalIcon from "@/assets/svg/pending-approval.vue";

export default {
    components: {
        ActionDropdown,
        FieldReadonly,
        UserProfileBadge,
        Tooltip,
        PendingApprovalIcon,
    },
    emits: [
        'updated',
        'deleted',
        'updating',
        'showEditModal',
        'editUsername',
    ],
    props: {
        applicationProfile: {
            type: Object,
            default() {
                return {};
            },
        },
        user: {
            type: Object,
            default() {
                return {};
            },
        },
        expiresAt: {
            type: String,
            default: null,
        },
        isPendingApproved: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
        };
    },
    methods: {
        getDate(date) {
            return formatDate(date);
        },
    },
    computed: {
        actions() {
            return [
                {
                    label: this.i18n('Edit'),
                    fn: () => {
                        this.$emit('showEditModal', { user: this.user, applicationProfile: this.applicationProfile });
                    },
                    if: this.user?.acl?.attachUserProfile || this.user?.acl?.update,
                    starred: true,
                }, {
                    label: this.i18n('Update User Application Username'),
                    fn: () => {
                        this.$emit('editUsername', { user: this.user, applicationProfile: this.applicationProfile });
                    },
                    if: (this.user?.acl?.update) === true && (!this.applicationProfile?.is_self && this.applicationProfile?.is_identity) && this.$root.features?.profiles?.application_username,
                    starred: false,
                }
            ];
        },
    },
};
</script>
<style scoped>
.card-no-border {
    border: none !important;
}
</style>